import localforage from 'localforage';

export const LocalForageId = Symbol.for('LocalForage');

const store = localforage.createInstance({
    name: 'mpc',
    version: 1.0,
    storeName: 'requests',
    description: 'Persistent storage for MPC requests.'
});

export default store;
